import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cart-widget__item__remove" }
const _hoisted_2 = {
  class: "col-12 col-xl",
  ref: "colLeft"
}
const _hoisted_3 = { class: "cart-widget__items__item__title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "fs-regular"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Das Produkt ")
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" aus Ihrem Warenkorb entfernen? ")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Das Produkt ")
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" aus Ihrem Warenkorb entfernen und die aktuelle Bestellung abbrechen? ")
const _hoisted_13 = { class: "row gx-0 gy-2" }
const _hoisted_14 = { class: "col-12 col-lg-auto" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg" }, null, -1)
const _hoisted_16 = { class: "col-12 col-lg-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: _ctx.product.name
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      (!_ctx.isOrderCancel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("i", {
              innerHTML: _ctx.product.name
            }, null, 8, _hoisted_7),
            _hoisted_8
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("i", {
              innerHTML: _ctx.product.name
            }, null, 8, _hoisted_11),
            _hoisted_12
          ])),
      _createVNode(_component_BaseSpacer, { size: "m" }),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$.emit('clear'))),
            class: "btn btn-outline-dark btn-sm w-100"
          }, " Nein ")
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onApprove && _ctx.onApprove(...args))),
            class: "btn btn-primary btn-sm w-100"
          }, " Ja ")
        ])
      ])
    ], 512)
  ]))
}